import { useEffect, useState } from 'react';

import PackagesSearchControlsGC, {
  fetchPlaceSuggestions,
} from '@skyscanner-internal/global-components/packages-search-controls';
import { redirect } from 'saddlebag-browser';
import logger from 'saddlebag-logger';

import withErrorBoundary from '../ErrorBoundary';

import getPackagesDayviewUrl from './utils/getPackagesDayviewUrl';

import type { SearchParams } from '@skyscanner-internal/global-components/packages-search-controls/types/search-results';
import type { PackagesSearchControlsGCWrapperProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/PackagesSearchControlsProps';

import STYLES from './PackagesSearchControlsGCWrapper.module.scss';

const onTriggerSearch = ({
  adults,
  childrenAges,
  destination,
  inboundDate,
  origin,
  outboundDate,
}: SearchParams) => {
  const redirectUrl = getPackagesDayviewUrl({
    origin,
    destination,
    outboundDate,
    inboundDate,
    adults,
    childrenAges,
    source: 'falcon-packages-search-controls',
  });
  redirect(redirectUrl);
};

const PackagesSearchControlsGCWrapper = ({
  cldr,
  culture,
  enabledMarkets,
  enabledPlaceTypes,
  isProductionEnv,
  searchParams,
  strings,
  trackingParams,
}: PackagesSearchControlsGCWrapperProps) => {
  // TODO: [WALL-2662] This is a temp until Backpack implements the fix,
  //  re-rendering on client as per breakpoint issue
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return (
      <div
        className={STYLES.fixedHeight}
        data-testid="packages-search-controls-gc-placeholder"
      />
    );
  }

  return (
    <PackagesSearchControlsGC
      key="client"
      xSkyscannerClient="falcon"
      onSearch={onTriggerSearch}
      isProductionEnv={isProductionEnv}
      cldr={cldr}
      searchParams={searchParams as any}
      trackingParams={trackingParams}
      strings={strings}
      culture={culture}
      logger={logger}
      enabledMarkets={enabledMarkets}
      enabledPlaceTypes={enabledPlaceTypes}
      fetchPlaceSuggestions={fetchPlaceSuggestions}
    />
  );
};

const PackagesSearchControlsWithErrorBoundary = withErrorBoundary(
  PackagesSearchControlsGCWrapper,
  'packages-search-controls-component',
);

export default PackagesSearchControlsWithErrorBoundary;
